import { ConstraintProvenUndrilledObligationBase } from './base/constraint-proven-undrilled-obligation-base';

export class ConstraintProvenUndrilledObligation extends ConstraintProvenUndrilledObligationBase { }